<template>
	<main>
		<div class="profile-container" v-if="!loading">
			<h1 style="font-size: 30px; color: white; text-align: center">
				{{ $t('Subscription Expired') }}
			</h1>
			<p style="font-size: 18px; color: white; text-align: center">
				{{ $t('Please resubscribe to continue using our services.') }}
			</p>
			<br />
			<button @click="resubscribe">{{ $t('Resubscribe') }}</button>
			<br />
			<button @click="logout">{{ $t('Logout') }}</button>
		</div>
		<div class="profile-container" v-else>
			<p>{{ $t('Checking Subscription ...') }}</p>
		</div>
	</main>
</template>

<script>
export default {
	props: {
		locals: Object,
	},
	data() {
		return {
			loading: true,
		};
	},
	mounted() {
		setTimeout(() => {
			if (this.locals.subscriber.content_access === true) {
				return this.$router.push('/profile');
			}
			this.loading = false;
		}, 1000);
	},
	methods: {
		resubscribe() {
			return (window.location.href = '/subscribe');
		},
		logout() {
			window.logout();
		},
		async unsubscribe() {
			await window.unsubscribe();
		},
	},
};
</script>
